export const API_BASE_URL = (type: string) => `${process.env.REACT_APP_API_URL_RESSOURCES}/faqs?type=${type}`;
export const API_FETCH_HELP = `${process.env.REACT_APP_API_URL_RESSOURCES}/help-assistant/fetch/assistant/emplacement`;
export const API_RESSOURCES = `${process.env.REACT_APP_API_URL_RESSOURCES}`;
